<script>
    import Terms from '../Terms.vue';
    import Confidentiality from '../Confidentiality.vue';

    export default {
        components: {
            Terms,
            Confidentiality
        },
        methods: {
            openModal(modal) {
                $('#' + modal).modal('show');
            },

            closeModal(modal) {
                $('#' + modal).modal('hide');
            },

            f_agreeTC() {
                this.closeModal('termsModal');
            },

            f_agreePC() {
                this.closeModal('confidentialityModal');
            }
        }
    }
</script>
